
import { Base } from '../base-component';

import './browser-detection.component.scss';

export class BrowserDetection extends Base {

	modal: Element;

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {

		if (this.isIE() && this.isIE() < 10) {
			this.openModal();
		}

	}

	bindEvents() {}

	openModal() {
		this.modal = this.element.querySelector('#browser-detection-modal-1');
		this.modal.classList.remove('modal--close');
		this.modal.classList.remove('modal--closed');
	}

	isIE () {

		const browser = navigator.userAgent.toLowerCase();

		// return (browser.indexOf('msie') != -1) ? parseInt(browser.split('msie')[1]) : false;
		return 9; // To test modal

	}

}



// WEBPACK FOOTER //
// ./components/browser-detection/browser-detection.component.ts